import { CIcon } from '~/icons/types'

export const ciFacebookMessenger: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M23 11.67c0 6.13-4.803 10.67-11 10.67-1.113 0-2.18-.147-3.184-.423a.877.877 0 0 0-.588.043l-2.183.964a.88.88 0 0 1-1.235-.778l-.06-1.957a.878.878 0 0 0-.296-.627C2.314 17.648 1 14.877 1 11.67 1 5.54 5.803 1 12 1s11 4.54 11 10.67Z',
      fill: '#0866FF'
    },
    {
      d:
        'm14.987 14.742 3.83-5.919c.385-.595-.329-1.287-.912-.885l-3.998 2.758a.404.404 0 0 1-.45.006L9.91 8.407a.648.648 0 0 0-.895.192l-3.83 5.919c-.385.594.328 1.287.911.884l3.999-2.757a.405.405 0 0 1 .45-.007l3.547 2.296c.3.194.702.108.896-.192Z',
      fill: '#fff'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'facebook-messenger',
  type: 'solid'
}
